import { call, put, takeEvery } from "redux-saga/effects";
import {
  premiumCalculatePostError,
  premiumCalculatePostSuccess,
} from "./actions";
import { PREMIUM_CALCULATE } from "./actionTypes";
import { postPremiumCalculate } from "../../resources/helper/premiumCalculation";

function* premiumCalculatePost({ payload: { calculateBody } }) {
  try {
    const response = yield call(postPremiumCalculate, calculateBody);
    yield put(premiumCalculatePostSuccess(response));
  } catch (error) {
    yield put(premiumCalculatePostError(error));
  }
}

function* PremiumCalculateSaga() {
  yield takeEvery(PREMIUM_CALCULATE, premiumCalculatePost);
}

export default PremiumCalculateSaga;
